import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
var Tiles = styled(Box).withConfig({
  componentId: "sc-4qnpzd-0"
})(["display:grid;grid-template-columns:", ";grid-auto-rows:1fr;place-items:start;gap:", ";", ""], function (_ref) {
  var columns = _ref.columns;
  return "repeat(" + columns + ", 1fr)";
}, function (_ref2) {
  var gutter = _ref2.gutter;
  return spacing(gutter || "md");
}, function (_ref3) {
  var direction = _ref3.direction,
      rows = _ref3.rows;
  return direction === "vertical" && css(["grid-auto-flow:column;grid-template-rows:repeat(", ",0fr);"], rows);
});
export { Tiles };